





























































import uploadFiles from '@/components/Reusable/uploadFiles.vue';
import { DocumentKindParams } from '@/store/interfaces/document';
import imagePreview from '@/components/Reusable/imagePreview.vue';
import { ValidationProvider } from 'vee-validate';
import Vue, { PropType } from 'vue';

type tDocument = {
  image: {
    name: string;
  };
  data: string;
  currentFileURL: string;
  register_document_data: {
    document: string;
    document_kind_id: string;
    identity_code: string;
    reference: string;
    status: 'active' | 'inactive';
  };
  url: string;
  document: string;
  size: number;
};

export default Vue.extend({
  name: 'NewDocument',
  components: { uploadFiles, imagePreview, },
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    url: {
      required: true,
      type: String,
    },
    isSaveSuccess: {
      required: true,
      type: Boolean,
    },
    typeDocument: {
      required: true,
      type: Array as PropType<DocumentKindParams[]>,
    },
  },
  data: () => ({
    document_number: 1,
    documents: [] as tDocument[],
    currentFile: null,
    reference: '',
    refDocument: '',
  }),
  watch: {
    isSaveSuccess(val: boolean): void {
      if (val) {
        this.$data.documents = [];
        this.clean();
      }
    },
  },
  methods: {
    trash(id: string): void {
      this.$data.documents = this.$data.documents.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (_value: any, index: number) => index !== parseInt(id)
      );
    },
    clean(): void {
      this.$data.document_number++;
      this.$data.reference = '';
      this.$data.currentFile = null;
      (
        this.$refs.formNewDocument as InstanceType<typeof ValidationProvider>
      ).reset();
    },
    saveDocument(): void {
      const size =
        Number((this.$data.currentFile.size / 1000000).toFixed(2)) + ' MB';
      const pos = this.typeDocument
        .map((doc: DocumentKindParams) => doc.id)
        .indexOf(this.$data.refDocument);
      const document = this.typeDocument[pos].name;
      const document_kind_id = this.typeDocument[pos].id;

      const documentInfo = {
        image: this.$data.currentFile,
        data: (this.$refs.document as InstanceType<typeof uploadFiles>).$data.data,
        currentFileURL: (this.$refs.document as InstanceType<typeof uploadFiles>).$data
          .currentFileURL,
        register_document_data: {
          document: (this.$refs.document as InstanceType<typeof uploadFiles>).$data.data
            .blob_signed_id,
          document_kind_id,
          identity_code: Math.random().toString(36).substring(2),
          reference: this.$data.reference,
          status: 'active',
        },
        url: this.url,
        document,
        size,
      };
      this.$data.documents.unshift(documentInfo);
      this.clean();
    },
  },
});
